module.exports = __webpack_public_path__ + "img/AURE_M.34ef9c2a.jpg";